export const API_EXTERNAL_ENDPOINT = 'search/cottage/:cottageId/gallery'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/cottage-gallery'
